import Nav from "./../Page/Share/Nav/Nav";
const Post27 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            E Structure Brand Guidelines
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/kq8jFj4/1.jpg" alt="" />
          <img src="https://i.ibb.co/K6FVdG9/2.jpg" alt="" />
          <img src="https://i.ibb.co/XkpPBgc/3.jpg" alt="" />
          <img src="https://i.ibb.co/M1DtfqL/4.jpg" alt="" />
          <img src="https://i.ibb.co/2y4YNgv/5.jpg" alt="" />
          <img src="https://i.ibb.co/s312JzK/6.jpg" alt="" />
          <img src="https://i.ibb.co/8cq3B2Y/7.jpg" alt="" />
          <img src="https://i.ibb.co/kXc8Sbn/8.jpg" alt="" />
          <img src="https://i.ibb.co/jD7Bshc/9.jpg" alt="" />
          <img src="https://i.ibb.co/HPWbn2R/10.jpg" alt="" />
          <img src="https://i.ibb.co/mcFpXYQ/11.jpg" alt="" />
          <img src="https://i.ibb.co/xLXNxRY/12.jpg" alt="" />
          <img src="https://i.ibb.co/6NpYm2Y/13.jpg" alt="" />
          <img src="https://i.ibb.co/LNBz7jf/14.jpg" alt="" />
          <img src="https://i.ibb.co/bHcbT1W/15.jpg" alt="" />
          <img src="https://i.ibb.co/bJZ360v/16.jpg" alt="" />
          <img src="https://i.ibb.co/NKLn5ZY/17.jpg" alt="" />
          <img src="https://i.ibb.co/QKTDCc0/18.jpg" alt="" />
          <img src="https://i.ibb.co/B2qYYGs/19.jpg" alt="" />
          <img src="https://i.ibb.co/fSFYGdQ/20.jpg" alt="" />
          <img src="https://i.ibb.co/PhX3y8B/21.jpg" alt="" />
          <img src="https://i.ibb.co/jVqtrJN/22.jpg" alt="" />
          <img src="https://i.ibb.co/yP1PF5w/25.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post27;
